import { LobbyStatus } from '../../enums';
import {
	IsBoolean,
	IsDate,
	IsEnum,
	IsNotEmpty,
	IsNumber,
	IsOptional,
	IsString,
	IsUUID,
	ValidateIf,
	ValidateNested,
} from 'class-validator';
import { Type } from 'class-transformer';

export class LobbyDetailDto {
	@IsOptional()
	@IsString()
	id?: string;

	@IsString()
	@IsNotEmpty()
	header: string;

	@IsString()
	@IsNotEmpty()
	content: string;

	@IsNumber()
	@IsNotEmpty()
	@Type(() => Number)
	order: number;
}

export class CreateLobbyDto {
	@ValidateIf((o) => o.is_private === true)
	@IsString()
	access_password?: string;

	@IsOptional()
	@IsString()
	description?: string;

	@IsUUID()
	@IsNotEmpty()
	event_id: string;

	@IsOptional()
	@IsBoolean()
	is_default?: boolean;

	@IsOptional()
	@IsBoolean()
	is_private?: boolean;

	@IsString()
	@IsNotEmpty()
	name: string;

	@IsOptional()
	@IsEnum(LobbyStatus)
	status?: LobbyStatus;

	@IsString()
	info: string;

	@IsString()
	prize: string;

	@IsOptional()
	@IsString()
	image_url?: string;

	@IsOptional()
	@IsString()
	image_id?: string;

	@IsOptional()
	@IsBoolean()
	is_chat_closed?: boolean;

	@IsOptional()
	@ValidateNested({ each: true })
	@Type(() => LobbyDetailDto)
	details?: LobbyDetailDto[];

	@IsOptional()
	@Type(() => Date)
	@IsDate()
	game_start_date?: Date;
}
